import { UpdateOrgFunctionRequestSchema, UpdateOrgFunctionResponseSchema } from './update-org-function.schema';
/**
 * Update OrgFunction Endpoint Contract
 * Updates an existing OrgFunction by ID
 */ export const updateOrgFunctionContract = {
    method: 'PATCH',
    path: '/api/v2/org-function/:id',
    description: 'Update an existing OrgFunction by ID',
    requestSchema: UpdateOrgFunctionRequestSchema,
    responseSchema: UpdateOrgFunctionResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            404: 'OrgFunction not found'
        }
    }
};

//# sourceMappingURL=update-org-function.contract.js.map